<div id="footerSection" class="footer">
    <span class="storeImg" *ngIf="storeLogo"></span>
    <div id="footerPrice" class="footer_price" *ngIf="price">{{price}}</div>
</div>